<template> 
  <div>    
    <barraprincipal @abrir="mtMenuVisible"></barraprincipal>   
    <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>  

    <v-container fluid>       

        <div class="claro elevation-5">
            <v-row dense>     
                <v-col cols="12" md="12" class="d-flex align-center px-4">
                    <h2 class="primary--text">{{titulo}}</h2>  
                </v-col>                    
            </v-row>
        </div> 

        <br>      

        <v-row>
            <v-col cols="12">
                <v-alert dense color="primary" class="claro--text" type="error" v-if="alerta">
                    <strong>Ya existe un trámite de traslado estudiantil en proceso</strong>
                </v-alert>
            </v-col>
        </v-row>
        
        <v-expansion-panels hover  v-model="panel_abierto">
            
            <v-expansion-panel>

                <v-expansion-panel-header>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12"><strong>Paso 1.- Llenado y descarga de solicitud</strong></v-col>  
                    </v-row>
                   
                </v-expansion-panel-header>                    
                           
        
                <v-expansion-panel-content>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12">
                            <v-alert color="secondary" type="info" dense>
                                Llena los campos para generar la solicitud, una vez generada, <strong>imprime, firma y escanea</strong>, para continuar con el Paso 2
                            </v-alert>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" xs="12" sm="3">
                            <v-text-field outlined dense label="Nombre" v-model="nombre" :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="3">
                            <v-text-field outlined dense label="Apellido paterno" v-model="apellido_paterno" :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="3">
                            <v-text-field outlined dense label="Apellido materno" v-model="apellido_materno" :rules="[rules.required]"></v-text-field>
                        </v-col>
                    </v-row>
            
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="3">
                            <v-text-field outlined dense label="Teléfono" v-model="telefono" :rules="[rules.required, rules.min10]"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="3">
                            <v-text-field outlined dense label="Correo" v-model="correo" :rules="[rules.required]"></v-text-field>
                        </v-col>
                    </v-row>
            
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="3">
                            <v-text-field outlined dense label="Número de control" v-model="no_control" :rules="[rules.required, rules.min8]"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="3">
                            <v-select :items="semestres" v-model="semestre" label="Semestre" outlined dense></v-select>
                        </v-col>
                    </v-row>
            
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="4">
                            <v-select :items="carreras_itp" v-model="carrera_itp_seleccionada" label="Carrera actual" outlined dense></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="4">
                            <v-select :items="carreras_destino" v-model="carrera_destino_seleccionada" label="Carrera destino" outlined dense></v-select>
                        </v-col>
                    </v-row>
            
                    <v-row dense>                      
                        <v-col cols="12" xs="12" sm="4">
                            <v-text-field outlined dense label="Destino" v-model="tec_destino" prefix="Instituto Tecnológico de" :rules="[rules.required]"></v-text-field>
                        </v-col>
                    </v-row>
            
                    <v-row dense>
                        <v-textarea outlined rows=3 label="Motivos de traslado" v-model="motivos" value="" dense></v-textarea>
                    </v-row>
            
                    <v-row dense>
                         <v-spacer/>
                        <v-col cols="12" xs="12" sm="2">
                            <v-btn color="primary" class="white--text" elevation="2" @click="genera_solicitud" :loading="generando_solicitud" :disabled="alerta">Generar solicitud</v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
                
                                                                    <!-- PASO 2 -->
            
            <v-expansion-panel>
                
                <v-expansion-panel-header>
                    <v-row>
                        <v-col><strong>Paso 2.- Carga de documentos</strong></v-col>
                    </v-row>
                </v-expansion-panel-header>
                    
                <v-expansion-panel-content>
                    <v-row>
                        <v-col>
                            <v-alert color="secondary" type="info" dense>
                                Sube los documentos escaneados, <strong>kardex y solicitud</strong> (generada en el Paso 1) firmada. 
                            </v-alert>
                        </v-col>
                    </v-row>
            
                    <v-row>
                        <v-col cols="12" xs="12" sm="4">
                            <v-file-input show-size outlined dense label="Kardex" v-model="kardex" accept="image/png, image/jpg, image/jpeg, application/pdf"></v-file-input>
                        </v-col>
                    </v-row>
            
                    <v-row>
                        <v-col cols="12" xs="12" sm="4">
                            <v-file-input show-size outlined dense label="Solicitud traslado" v-model="anexoII" accept="image/png, image/jpg, image/jpeg, application/pdf"></v-file-input>
                        </v-col>
                    </v-row>
            
                    <v-row dense>
                        <v-spacer/>
                        <v-col cols="12" xs="12" sm="2">
                            <v-btn color="primary" class="white--text" elevation="2" @click="sube_archivos" :disabled="alerta">Subir documentos</v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>       


        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbar_color"> {{snackbar_texto}} </v-snackbar>
        <v-dialog v-model="dialogo" transition="dialog-bottom-transition" max-width="600">
           <v-card>
               <v-toolbar color="primary" class="claro--text"><b>Trámite iniciado</b></v-toolbar>
               <v-card-text>                   
                    <div class="pt-8 pb-3 pl-3 pr-3">
                        Has iniciado el trámite de <strong>Traslado Estudiantil,</strong> 
                        podrás dar seguimiento en la opción <strong>Estatus de trámites. </strong> 
                    </div>                    
               </v-card-text>
               <v-card-actions class="justify-end">
                   <v-btn color="secondary"  @click="dialogo = false">Cerrar</v-btn>
               </v-card-actions>
           </v-card>           
        </v-dialog>
    </v-container>

  </div>
</template>

<script>

import menulateral from '@/components/MenuLateral'
import barraprincipal from '@/components/BarraPrincipal'

export default {
  components:{
    menulateral,
    barraprincipal
  },
    data() {
        return {
            menu_visible: false,
            
            alerta: false,
            dialogo: false,

            snackbar: false,
            snackbar_texto: "",
            snackbar_color: "success",

            panel_abierto: 0,
            
            titulo: 'Solicitud de Traslado Estudiantil',
            carreras_itp: [],
            carreras_destino: [],

            carrera_itp_seleccionada: null,
            carrera_destino_seleccionada: null,
            nombre: "",
            apellido_paterno: "",
            apellido_materno: "",
            telefono: "",
            correo: "",
            no_control: "",
            semestre: null,
            tec_destino: "",
            motivos: null,     
            
            kardex: null,
            anexoII: null,
            porcentaje_subido: '',

            semestres: [
                {text: 'Primer', value: '1'},
                {text: 'Segundo', value: '2'},
                {text: 'Tercer', value: '3'},
                {text: 'Cuarto', value: '4'},
                {text: 'Quinto', value: '5'},
                {text: 'Sexto', value: '6'},
                {text: 'Séptimo', value: '7'},
                {text: 'Octavo', value: '8'},
                {text: 'Noveno', value: '9'},
                {text: 'Décimo', value: '10'},
                {text: 'Undécimo', value: '12'}
            ],

            rules: {
                required: value => !!value || 'Requerido.',
                min8: v => v.length >= 8 && v.length <= 9 || '8-9 caracteres',
                min10: v => v.length >= 10 && v.length <= 10 || '10 caracteres',          
            },

            generando_solicitud: false
        
        }
    },

    watch: {
        telefono() {
            this.telefono = this.telefono.replace(/[^0-9]/g, '') 
        },        
        nombre(){
            if(this.nombre)
                this.nombre = this.nombre.charAt(0).toUpperCase() + this.nombre.slice(1)
        },
        apellido_paterno(){
            if(this.apellido_paterno)
                this.apellido_paterno = this.apellido_paterno.charAt(0).toUpperCase() + this.apellido_paterno.slice(1)
        },
        apellido_materno(){
            if(this.apellido_materno)
                this.apellido_materno = this.apellido_materno.charAt(0).toUpperCase() + this.apellido_materno.slice(1)
        }
    },

    beforeCreate() {
        const token = sessionStorage.getItem('data')
        
        if(token == null)
            this.$router.push({name:'Login'})

        /* Consultar informacion del alumno */
        this.axios.get(this.$url+'/alumno/datos', {headers: {Authorization: `Bearer ${token}`}})
        .then((rs)=>{
            if(rs.data.error){
                console.log("Error al consultar información");
            }
            else{         
                this.calumno = rs.data.calumno
                this.nombre = rs.data.nombre
                this.apellido_paterno = rs.data.apellido_paterno
                this.apellido_materno = rs.data.apellido_materno
                this.no_control = rs.data.no_control
                this.telefono = rs.data.telefono
                this.correo = rs.data.correo        
                this.carrera = rs.data.ccarrera        
            }
        })
        .catch((error)=>{
            console.log("Error "+ error);
        })
    },

    created() {

        const token = sessionStorage.getItem('data')

        this.nombre = sessionStorage.getItem('nombre')
        this.apellido_paterno = sessionStorage.getItem('apellido')
        this.correo = sessionStorage.getItem('correo')


        this.axios.get(this.$url+'/carreras', {headers: {Authorization: `Bearer ${token}`}})
            .then((response) => {
                console.log(response.data);
                console.log("Carga incial");
                
                
                for(let carrera of response.data){
                    

                    this.carreras_itp.push({text: carrera.nombre, value: {"ccarrera":carrera.ccarrera, "nombre":carrera.nombre, "plan_estudios":carrera.plan_estudios}})
                    this.carreras_destino.push({text: carrera.nombre, value: {"ccarrera":carrera.ccarrera, "nombre":carrera.nombre, "plan_estudios":carrera.plan_estudios}})
                }
                
            })
            .catch(function (error) {
                console.log(error);
            })
        
        /* Validar si tiene el tramite en proceso */
        this.axios.get(this.$url+'/tramites/estatus/1', {headers: {Authorization: `Bearer ${token}`}})
            .then( (response) =>{
                if(response.data.error)
                    this.alerta = false
                else{
                    this.alerta = response.data.existe

                    if(response.data.existe)
                        this.panel_abierto = -1

                }
            })
            .catch((error)=>{
                console.log("Error al validar tramite "+error);
            })
       

        // /* Traer informacion del alumno */
        // this.axios.get(this.$url+'/alumno/datos', {headers: {Authorization: `Bearer ${token}`}})
        //     .then((response)=>{
        //     if(response.data.error){
        //         console.log("Error al consultar información");
        //     }
        //     else{
        //         for(let alumno of response.data){
        //             this.nombre = alumno.nombre
        //             this.apellido_paterno = alumno.apellido_paterno
        //             this.apellido_materno = alumno.apellido_materno
        //             this.no_control = alumno.no_control
        //             this.telefono = alumno.telefono

                    

        //             for(let car of this.carreras_itp){ 
        //                 if(car.value.ccarrera == alumno.ccarrera){
        //                     console.log(this.carrera_itp_seleccionada)
        //                     this.carrera_itp_seleccionada = {"ccarrera": car.value.ccarrera, "nombre": car.value.nombre, "plan_estudios": car.value.plan_estudios}
        //                     console.log(this.carrera_itp_seleccionada)
        //                 }
        //             }
        //         }
        //     }
        //     }) 
        //     .catch((error)=>{
        //         console.log("Error datos usuario "+error);
        //     }) 
    },


    methods: {

        mtMenuVisible(value){
            this.menu_visible = value
        },

        genera_solicitud() {
            
            const datos_solicitud = {
                "nombre": this.nombre,
                "apellido_paterno": this.apellido_paterno,
                "apellido_materno": this.apellido_materno,
                "telefono": this.telefono,
                "correo": this.correo,
                "semestre": this.semestre,
                "no_control": this.no_control,
                "carrera_actual": this.carrera_itp_seleccionada.nombre,
                "plan_estudios_actual": this.carrera_itp_seleccionada.plan_estudios,
                "tec_destino": this.tec_destino,
                "carrera_destino": this.carrera_destino_seleccionada.nombre,
                "plan_estudios_destino": this.carrera_destino_seleccionada.plan_estudios,
                "motivos": this.motivos
            }
           
            this.axios.post(this.$url+'/traslado/solicitud/crear', {"datos_solicitud": datos_solicitud})
                .then((response)=>{
                    if (response.data.estatus){                                
                        setTimeout(() => {
                            window.open(response.data.archivo, "Formato de solicitud")                            
                        }, 500);
                    }
                })
                .catch((error)=>{
                    console.log("Error al crear solicitud de traslado "+error);
                })

        },

        met_kardex(event){
            this.kardex = event.target.files[0]

            console.log(event.target.files[0]);  
            console.log(event.target.files[0].name);  
            console.log(event.target.files[0].size / 1024 )  
            console.log(event.target.files[0].type);  
        },
        
        met_anexoII(event){
            this.anexoII = event.target.files[0]
        },

        sube_archivos(){

            const token = sessionStorage.getItem('data')
            
            let data = new FormData();

            data.set('enctype', 'multipart/form-data')
            data.append('kardex', this.kardex)
            data.append('anexoII', this.anexoII)
            data.append('correo', this.correo)
            data.append('_method', 'PUT')

            //Mostrar mensaje en pantalla
            //this.dialogo_mensaje ='Subiendo archivo'
            
            if(this.kardex == null || this.anexoII == null ){
                this.porcentaje_subido = "Los dos archivos son requeridos"                        
                return 
            }

            
            this.axios.put(this.$url+'/traslado/solicitud/subir',data,                         
                        {
                            headers: {Authorization: `Bearer ${token}`},
                            onUploadProgress: progressEvent =>{                            
                                this.porcentaje_subido ='Subiendo archivos... '+ Math.round(progressEvent.loaded / progressEvent.total * 100) + "%"                                
                            }
                        }                        
                    )
                .then((response)=>{
                    if(response.data){
                        if(response.data.error){
                            this.snackbar = true;
                            this.snackbar_color = "error";
                            this.snackbar_texto = response.data.mensaje
                        }
                        else{
                            this.snackbar = true;
                            this.snackbar_color = "success";
                            this.snackbar_texto = response.data.mensaje
                            this.dialogo = true

                            //this.$router.push({name:"EstatusTramites"})

                        }
                    }
                    else{
                        this.snackbar = true;
                        this.snackbar_color = "error";
                        this.snackbar_texto = "Error al subir documentos, intente mas tarde." 
                    }
                })
                .catch(()=>{
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_texto = "Error al subir documentos, intente mas tarde."                    
                })
                
        },
    },
  
};

</script>